"use client"

import partner1 from "../../assets/patner1.jpeg"
import partner2 from "../../assets/patner2.jpeg"
import partner3 from "../../assets/patner3.jpeg"
import partner4 from "../../assets/partner4.png"
import partner5 from "../../assets/partner5.png"
import partner6 from "../../assets/partner6.png"
import partner7 from "../../assets/partner7.jpeg"
import partner8 from "../../assets/partner8.png"
import partner9 from "../../assets/partner9.png"

import TextFade from "../../components/CustomTexts/TextFade"
import TextEffect from "../../components/CustomTexts/TextEffect"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Autoplay } from "swiper/modules"
import "swiper/css"
import "swiper/css/navigation"

const partners = [
  { img: partner1, caption: "Federal Ministry of Women Affairs" },
  { img: partner2, caption: "Nigeria Agricultural Quarantine Service" },
  { img: partner3, caption: "Kogi State Enterprise Development Agency" },
  { img: partner4, caption: "Nana Global Fleet Enterprises Zamfara State" },
  { img: partner5, caption: "BuyNaija" },
  { img: partner6, caption: "Federal Ministry of Industry Trade and Investment" },
  { img: partner7, caption: "Olu Olu Nigeria Limited Ilesha" },
  { img: partner8, caption: "Federal Ministry of Agriculture and Food Security" },
   { img: partner9, caption: "Federal Ministry of Agriculture and Food Security" } // Re-using img1
]

const ClientStrategy = () => {
  return (
    <div className="px-4 sm:px-[5%] mt-24 mb-20">
      <TextFade animation="fade-up">
        <h1 className="text-center text-[20px] md:text-[30px] font-bold text-dark mb-8">
          <TextEffect text2="Clients and Strategic Partners" />
        </h1>
      </TextFade>

      <Swiper
        spaceBetween={20}
        slidesPerView={2}
        breakpoints={{
          640: { slidesPerView: 3 },
          768: { slidesPerView: 4 },
          1024: { slidesPerView: 5 },
        }}
        navigation
        autoplay={{ delay: 2500 }}
        loop
        modules={[Navigation, Autoplay]}
      >
        {partners.map(({ img, caption }, index) => (
          <SwiperSlide key={index}>
            <div className="relative w-full h-[120px] flex items-center justify-center bg-white rounded-lg shadow-sm p-4 transition-transform hover:scale-105 cursor-pointer">
              <img
                src={img}
                alt={caption}
                className="max-h-[80px] object-contain"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default ClientStrategy
